<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-file text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">Documentos</span>
      </div>
    </div>
    <div class="row py-3 mr-md-0">
      <div
        v-for="(item, index) in listOfDocuments"
        :key="`${index}-${item.contractDocumentId}`"
        class="col-12 col-md-12"
      >
        <custom-callout
          class-main="mt-3"
          :has-border="true"
          :has-gradient="false"
          :has-toggle="false"
        >
          <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
            <div class="col-2 my-2">
              <div class="color-gray-6 font-14">Tipo de Documento:</div>
              <div class="color-black font-16 font-weight-bold">
                {{ item.documentTypeName | empty }}
              </div>
            </div>
            <div class="col-4 my-2">
              <div class="color-gray-6 font-14">Nombre del Archivo:</div>
              <div class="color-black font-16 font-weight-bold">
                {{ item.filename | empty }}
              </div>
            </div>
            <div class="col-2 my-2">
              <div class="color-gray-6 font-14">Fecha:</div>
              <div class="color-black font-16 font-weight-bold">
                {{ item.lastModifyDate | date }}
              </div>
            </div>
            <div
              class="col-12 col-md text-sm-right row justify-content-end align-items-center"
            >
              <custom-file-input
                v-if="
                  hasReplaceDocumentPermission &&
                    item.canReplace &&
                    showReplaceAction &&
                    isDocReplaceable(item.documentTypeId)
                "
                ref="fileReplacementDocumentInputRef"
                accept=".pdf"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                allow-accept-terms
                class="file-replacement-input__extended"
                display-style="normal"
                label-position="right"
                name=" "
                :on-download="() => onDownloadFileHandler(item)"
                @input="(file) => onReplacementFileHandler(file, item)"
              />
              <div>
                <action-button
                  id="btn-download-document"
                  class="btn-action-size mr-2"
                  i="fas fa-file-download"
                  variant="success"
                  @click="
                    () =>
                      item.documentId
                        ? onDownloadFileHandler(item)
                        : onDownloadPeiReportHandler(item)
                  "
                />
                <action-button
                  v-if="item.canDelete"
                  id="btn-delete-document"
                  class="btn-action-size mr-2"
                  i="fas fa-times"
                  variant="danger"
                  @click="() => onRemoveFileHandler(item)"
                />
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
    <validation-observer
      ref="contractAdditionalDocumentsForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row py-3 mr-md-0">
        <div class="col-12 col-md-4">
          <label class="data-title mb-0">Tipo de Documento:</label>
          <validation-provider
            v-slot="{ errors }"
            name="modality"
            rules="required"
          >
            <custom-drop-down
              id="ddlModality"
              v-model="model.documentType"
              custom-error-msg="El tipo de documento es requerido"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="documentsTypes"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="fileUpload"
            rules="required"
          >
            <label class="data-name">Archivo:</label>
            <custom-file-input
              id="fileUpload"
              ref="proRemfileUpload"
              :accept="'.pdf'"
              accept-terms-modal-title="Certificación"
              accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
              accept-terms-title="Acepto los términos y responsabilidades"
              accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
              allow-accept-terms
              :custom-error-msg="'El documento es requerido.'"
              display-style="normal"
              :error="errors[0]"
              :on-download="onDownloadFile"
              required
              :value="model.attachment"
              @input="
                (file) => {
                  if (file) {
                    model.attachment = file;
                  }
                }
              "
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 mt-4 mr-3">
              <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
                <div class="bd-highlight ml-2">
                  <action-button
                    id="btn-add-document"
                    i="fas fa-save fa-lg"
                    text="Guardar"
                    variant="success"
                    @click="onUploadFileHandler"
                  />
                </div>
                <div class="mx-0 bd-highlight">
                  <action-button
                    id="btn-cancelar"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger"
                    @click="onCancelHandler"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import utils from '@/utils/utilities';

//constants
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';

import {
  saveContractDocument as _saveContractDocument,
  deleteAdditionalContractDocument as _deleteAdditionalContractDocument,
} from '@/services/uspqrp/contract.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import ReportServices from '@/services/common/report.api';

export default {
  name: 'ContractAdditionalDocuments',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
    ActionButton,
    CustomFileInput,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      model: {},
      showReplaceAction: true,
    };
  },
  computed: {
    documentsTypes() {
      var excludedDocumentTypes = [
        rpContractDocumentTypes.AttendanceSheet,
        rpContractDocumentTypes.PrBackgroundCheckProgramCertification,
        rpContractDocumentTypes.SinglePermit,
        rpContractDocumentTypes.PrBackgroundCheck300,
      ];

      var result = (this.data.documentsTypes || []).filter(
        (dt) =>
          !(this.listOfDocuments || [])?.some(
            (d) =>
              d.documentTypeId == dt.id &&
              dt.id != rpContractDocumentTypes.Others
          )
      );

      return result.filter((dt) => !excludedDocumentTypes.includes(dt.id));
    },
    contractId() {
      return this.data.contractId;
    },
    academicYearId() {
      return this.data.academicYearId;
    },
    listOfDocuments() {
      return this.data.documents;
    },
    hasReplaceDocumentPermission() {
      return this.userHasPermissions(
        'rempro.providers.contract.replacementdocument'
      );
    },
  },
  methods: {
    async onReplacementFileHandler(file, item) {
      if (file && item.contractDocumentId) {
        await this.saveContractDocument(
          item.documentTypeId,
          file,
          item.contractDocumentId
        );
        this.$refs.fileReplacementDocumentInputRef[0].removeFile();
        this.$emit('on-refresh-document');
        this.showReplaceAction = false;
        this.$nextTick(() => {
          this.showReplaceAction = true;
        });
      }
    },
    isDocReplaceable(documentTypeId) {
      let allowDocTypes = [
        rpContractDocumentTypes.Others,
        rpContractDocumentTypes.InterventionPlan,
        rpContractDocumentTypes.ProgressReport,
        rpContractDocumentTypes.AttendanceSheet,
      ];

      return allowDocTypes.some((docTypeId) => docTypeId === documentTypeId);
    },
    async onUploadFileHandler() {
      const isFormValid = await this.$refs.contractAdditionalDocumentsForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      if (this.contractId) {
        await this.saveContractDocument(
          this.model.documentType.id,
          this.model.attachment
        );
      }
    },
    async saveContractDocument(
      contractDocumentTypeId,
      file,
      contractDocumentId = null
    ) {
      const payload = objectToFormData(
        {
          contractId: this.contractId,
          academicYearId: this.academicYearId,
          contractDocumentTypeId,
          file,
          contractDocumentId,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      const { data } = await _saveContractDocument(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });
      if (data) {
        this.ShowToast(
          `Confirmación`,
          'El documento ha sido añadido exitosamente.',
          'success'
        );
        this.model = {};
        this.$refs.contractAdditionalDocumentsForm.reset();
        this.$refs.proRemfileUpload.removeFile();
        this.$emit('refresh-documents');
      }
    },
    async onDownloadFile() {
      return new Promise();
    },
    onDownloadFileHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
    async onDownloadPeiReportHandler({ peiId }) {
      if (peiId) {
        await ReportServices.getReport('peiorps', {
          peiId,
        })
          .then((res) => utils.convertToBlob(res.data))
          .catch((err) => {
            this.ShowToast(
              'Alerta',
              err.response?.data?.message || 'error',
              'error'
            );
          });
      }
    },
    async onRemoveFileHandler({ contractDocumentId }) {
      if (contractDocumentId) {
        await _deleteAdditionalContractDocument(contractDocumentId)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'Documento eliminado satisfactoriamente.',
              'success'
            );
          })
          .catch((err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            );
          });
        this.$emit('refresh-documents');
      }
    },
    onCancelHandler() {
      this.model = {};
      this.$refs.contractAdditionalDocumentsForm.reset();
      this.$refs.proRemfileUpload.removeFile();
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
@import '~@/shared/scss/config/colors.scss';
.btn-action-size {
  width: 38px;
  height: 38px;
}

.file-replacement-input__extended {
  margin: unset !important;
}

.btn-action-size > i {
  margin-right: 0 !important;
}

.file-replacement-input__extended .file-input-container {
  width: 38px !important;
  height: 38px !important;
  border-color: map-get($colors, 'green');
  margin-right: unset !important;
}

.file-replacement-input__extended
  .file-input-container
  em.fas.fa-file-plus.pr-4.text-green:before {
  content: '\f0e2';
}

.file-replacement-input__extended .file-input-container span {
  display: none;
}
.file-replacement-input__extended div.button-container {
  display: none !important;
}
</style>
